import { Injectable, EventEmitter } from '@angular/core';
import { IKart, IKartTuru, IIcerik, IVT, IYollar } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { IParametreSetiGrubu } from '@/src/service/fikoyt-ui/interfaces/IParametreSeti.interface';
import { ISablon } from '@/src/service/fikoyt-ui/src/lib/paylasim-sistemi/sablon-editoru/sablon.interface';
import { FikoYTId } from '@/src/service/fikoyt-ui/helpers/FikoYTId';
import { personelAcilirKutu, TR_RX_FN } from '../projeler/hmi-ortak-helpers';

const UYG = 'FikoYT.sistem.hmi.uretim';

@Injectable({ providedIn: 'root' })
export class HmiUretimService {
  paylasimYapildi = new EventEmitter<any>(true);
  aktifIcerikNo = 0;

  kart: IKart = {
    _id: new FikoYTId().toString(),
    vt: 'FikoYT.sistem.hareketler' as IVT,
    yol: 'FikoYT.sistem.hareketler.kalem' as IYollar,
    turu: IKartTuru.KART,
    gizlilik: 'Herkese Açık',
    kisiler: [],
    veri: {
      solSimge: { aciklama: undefined, baslik: 'HMI', renkArka: '#f5222d', renkYazi: '#fff' },
      kurdela: { aciklama: undefined, baslik: 'Üretim', renkArka: undefined, renkYazi: undefined },
      icerikler: [
        { _id: new FikoYTId().toString(), html: '', aciklama: '', sifre: null } as IIcerik,
      ],
    },
  };

  readonly parametreSetleri: IParametreSetiGrubu[] = [
    /* {
      id: 'hmi.makine-tanimi',
      baslik: 'Makine Tanımı',
      simge: '⚙️',
      aciklama: 'Makine ve tezgah tanımla',
      renk: 'linear-gradient(135deg, #78350f, #f59e0b)',
      kaynak: 'kod',
      bilesen: 'makine-tanimi',
      altKartSablonlari: [
        {
          id: 'hmi.makine.bakim-plani',
          baslik: 'Bakım Planı',
          simge: '🔧',
          parametreler: [
            { turu: 'Yazı', ismi: 'bakimTuru', baslik: 'Bakım Türü', ayarlar: { zorunlu: true, placeholder: 'Örn: Yağ Değişimi' } },
            {
              turu: 'Açılır Kutu', ismi: 'periyot', baslik: 'Periyot', ayarlar: {
                zorunlu: true,
                secenekler: [
                  { label: 'Günlük', value: 'Günlük' },
                  { label: 'Haftalık', value: 'Haftalık' },
                  { label: 'Aylık', value: 'Aylık' },
                  { label: 'Yıllık', value: 'Yıllık' },
                ],
              }
            },
            { turu: 'Sayı', ismi: 'sure', baslik: 'Süre (Dakika)', ayarlar: { min: 1 } },
            { turu: 'Yazı', ismi: 'sonrakiTarih', baslik: 'Sonraki Tarih', ayarlar: { placeholder: 'YYYY-MM-DD' } },
            { turu: 'Yazı', ismi: 'sorumlu', baslik: 'Sorumlu', ayarlar: { placeholder: 'Teknisyen adı' } },
            { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar', ayarlar: { placeholder: 'Özel talimatlar...' } },
          ],
          sablon: {
            genislik: 520, yukseklik: 220, mod: 'serbest',
            arkaPlan: { tur: 'gradient', deger: 'linear-gradient(145deg, #1a1a2e 0%, #0f3460 50%, #16213e 100%)' },
            bolgeler: [],
            elementler: [
              { id: 'bp0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 4, stil: { fill: 'rgba(3,105,161,0.6)' } },
              { id: 'bp1', tur: 'sabit-metin', icerik: '🔧', x: 5, y: 6, genislik: 44, yukseklik: 44, stil: { fontSize: 28, textAlign: 'center', verticalAlign: 'center' } },
              { id: 'bp2', tur: 'parametre-metin', parametreAnahtari: 'bakimTuru', x: 14, y: 6, genislik: 280, yukseklik: 26, stil: { fontSize: 16, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
              { id: 'bp3', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 35, genislik: 6, yukseklik: 185, stil: { fill: '#0369a1' } },
              { id: 'bp4', tur: 'sabit-metin', icerik: 'PERİYOT', x: 10, y: 45, genislik: 100, yukseklik: 10, stil: { fontSize: 6, fontWeight: '700', color: 'rgba(255,255,255,0.3)', letterSpacing: 2 } },
              { id: 'bp5', tur: 'parametre-metin', parametreAnahtari: 'periyot', x: 10, y: 52, genislik: 120, yukseklik: 20, stil: { fontSize: 13, fontWeight: '700', color: '#7dd3fc', verticalAlign: 'center' } },
              { id: 'bp6', tur: 'sabit-metin', icerik: 'SÜRE', x: 135, y: 45, genislik: 60, yukseklik: 10, stil: { fontSize: 6, fontWeight: '700', color: 'rgba(255,255,255,0.3)', letterSpacing: 2 } },
              { id: 'bp7', tur: 'parametre-metin', parametreAnahtari: 'sure', x: 135, y: 52, genislik: 50, yukseklik: 20, stil: { fontSize: 13, fontWeight: '600', color: '#94a3b8', verticalAlign: 'center' } },
              { id: 'bp7a', tur: 'sabit-metin', icerik: 'dk', x: 155, y: 53, genislik: 30, yukseklik: 18, stil: { fontSize: 8, fontWeight: '600', color: 'rgba(148,163,184,0.6)', verticalAlign: 'center' } },
              { id: 'bp8', tur: 'sabit-metin', icerik: 'SONRAKİ', x: 200, y: 45, genislik: 80, yukseklik: 10, stil: { fontSize: 6, fontWeight: '700', color: 'rgba(255,255,255,0.3)', letterSpacing: 2 } },
              { id: 'bp9', tur: 'parametre-metin', parametreAnahtari: 'sonrakiTarih', x: 200, y: 52, genislik: 100, yukseklik: 20, stil: { fontSize: 11, fontWeight: '600', color: '#94a3b8', verticalAlign: 'center' } },
              { id: 'bp10', tur: 'sabit-metin', icerik: 'SORUMLU', x: 10, y: 85, genislik: 80, yukseklik: 10, stil: { fontSize: 6, fontWeight: '700', color: 'rgba(255,255,255,0.3)', letterSpacing: 2 } },
              { id: 'bp11', tur: 'parametre-metin', parametreAnahtari: 'sorumlu', x: 10, y: 92, genislik: 180, yukseklik: 18, stil: { fontSize: 11, fontWeight: '600', color: '#94a3b8', verticalAlign: 'center' } },
              { id: 'bp12', tur: 'sekil', sekilTuru: 'dikdortgen', x: 5, y: 115, genislik: 460, yukseklik: 3, stil: { fill: 'rgba(255,255,255,0.08)', borderRadius: 2 } },
              { id: 'bp13', tur: 'sabit-metin', icerik: 'NOTLAR', x: 8, y: 120, genislik: 60, yukseklik: 10, stil: { fontSize: 6, fontWeight: '700', color: 'rgba(255,255,255,0.25)', letterSpacing: 2 } },
              { id: 'bp14', tur: 'parametre-metin', parametreAnahtari: 'notlar', x: 8, y: 128, genislik: 470, yukseklik: 40, stil: { fontSize: 10, fontWeight: '500', color: '#64748b', lineHeight: 1.3 } },
              { id: 'bp15', tur: 'sekil', sekilTuru: 'dikdortgen', x: 5, y: 175, genislik: 460, yukseklik: 2, stil: { fill: 'rgba(3,105,161,0.3)' } },
              { id: 'bp16', tur: 'sabit-metin', icerik: '◆ BAKIM PLANI', x: 5, y: 185, genislik: 120, yukseklik: 14, stil: { fontSize: 7, fontWeight: '600', color: 'rgba(3,105,161,0.4)', letterSpacing: 2 } },
            ],
          } as ISablon,
        },
        { id: 'hmi.makine.ariza-kaydi', baslik: 'Arıza Kaydı', simge: '⚠️', bilesen: 'ariza-kaydi' },
      ],
    },
    {
      id: 'hmi.is-emri',
      baslik: 'İş Emri',
      simge: '📋',
      aciklama: 'İş emri oluştur ve takip et',
      renk: 'linear-gradient(135deg, #1a237e, #1565c0)',
      kaynak: 'kod',
      bilesen: 'is-emri',
      altGruplar: [
        {
          id: 'hmi.is-emri.ekle',
          baslik: 'Yeni İş Emri',
          simge: '📋',
          aciklama: 'İş emri oluştur',
          parametreler: [
            { turu: 'Otomatik Kod', ismi: 'emirNo', baslik: 'Emir No', ayarlar: { kodFormat: '{PREFIX}-{YIL}-{AY}-{SAYI:3}', kodPrefix: 'IE' } },
            { turu: 'Yazı', ismi: 'urunAdi', baslik: 'Ürün Adı', ayarlar: { zorunlu: true } },
            { turu: 'Sayı', ismi: 'miktar', baslik: 'Miktar', ayarlar: { min: 1 } },
            {
              turu: 'Açılır Kutu', ismi: 'birim', baslik: 'Birim', ayarlar: {
                secenekler: [
                  { label: 'Adet', value: 'Adet' }, { label: 'Kg', value: 'Kg' }, { label: 'Metre', value: 'Metre' },
                  { label: 'Litre', value: 'Litre' }, { label: 'Ton', value: 'Ton' },
                ],
              }
            },
            {
              turu: 'Açılır Kutu', ismi: 'oncelik', baslik: 'Öncelik', ayarlar: {
                itemSablon: { aktif: true, simgeGoster: false, renkGoster: true, aciklamaGoster: false, resimGoster: false },
                secenekler: [
                  { label: 'Normal', value: 'Normal', renk: '#52c41a' },
                  { label: 'Acil', value: 'Acil', renk: '#fa8c16' },
                  { label: 'Kritik', value: 'Kritik', renk: '#f5222d' },
                ],
              }
            },
            { turu: 'Tarih', ismi: 'hedefTarih', baslik: 'Hedef Tarih' },
            personelAcilirKutu('sorumlu', 'Sorumlu'),
            { turu: 'Yazı Alanı', ismi: 'aciklama', baslik: 'Açıklama' },
          ],
          sayfaKurallari: { yeniSayfaEngelle: true },
          sablon: {
            genislik: 520, yukseklik: 240, mod: 'serbest',
            arkaPlan: { tur: 'gradient', deger: 'linear-gradient(145deg, #0d1a3a 0%, #1a237e 50%, #1565c0 100%)' },
            bolgeler: [],
            elementler: [
              { id: 'ie0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 5, stil: { fill: 'rgba(255,255,255,0.15)' } },
              { id: 'ie1', tur: 'sabit-metin', icerik: '📋', x: 5, y: 8, genislik: 50, yukseklik: 50, stil: { fontSize: 32, textAlign: 'center', verticalAlign: 'center' } },
              { id: 'ie1a', tur: 'sekil', sekilTuru: 'dikdortgen', x: 16, y: 8, genislik: 80, yukseklik: 22, stil: { fill: 'rgba(255,255,255,0.1)', borderRadius: 4 } },
              { id: 'ie1b', tur: 'sabit-metin', icerik: 'İŞ EMRİ', x: 16, y: 8, genislik: 80, yukseklik: 22, stil: { fontSize: 9, fontWeight: '700', color: 'rgba(144,202,249,0.8)', textAlign: 'center', verticalAlign: 'center', letterSpacing: 2 } },
              { id: 'ie1c', tur: 'parametre-render', parametreAnahtari: 'emirNo', x: 55, y: 8, genislik: 160, yukseklik: 22, stil: { fontSize: 9, fontWeight: '600', color: 'rgba(144,202,249,0.6)', letterSpacing: 1, verticalAlign: 'center' } },
              { id: 'ie2', tur: 'parametre-metin', parametreAnahtari: 'urunAdi', x: 5, y: 22, genislik: 420, yukseklik: 40, stil: { fontSize: 22, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
              { id: 'ie3', tur: 'parametre-render', parametreAnahtari: 'miktar', x: 5, y: 48, genislik: 80, yukseklik: 36, stil: { fontSize: 28, fontWeight: '800', color: '#90caf9', textAlign: 'center', verticalAlign: 'center' } },
              { id: 'ie3a', tur: 'parametre-render', parametreAnahtari: 'birim', x: 22, y: 52, genislik: 60, yukseklik: 20, stil: { fontSize: 12, fontWeight: '600', color: 'rgba(144,202,249,0.7)', verticalAlign: 'center' } },
              { id: 'ie4a', tur: 'sekil', sekilTuru: 'dikdortgen', x: 55, y: 48, genislik: 100, yukseklik: 30, stil: { fill: 'rgba(255,255,255,0.08)', borderRadius: 15 } },
              { id: 'ie4', tur: 'parametre-render', parametreAnahtari: 'oncelik', x: 55, y: 48, genislik: 100, yukseklik: 30, stil: { fontSize: 12, fontWeight: '700', color: '#ffffff', textAlign: 'center', verticalAlign: 'center' } },
              { id: 'ie5', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 80, genislik: 520, yukseklik: 50, stil: { fill: 'rgba(0,0,0,0.25)' } },
              { id: 'ie5a', tur: 'sabit-metin', icerik: 'HEDEF TARİH', x: 5, y: 82, genislik: 120, yukseklik: 14, stil: { fontSize: 7, fontWeight: '700', color: 'rgba(255,255,255,0.35)', letterSpacing: 2 } },
              { id: 'ie5b', tur: 'parametre-render', parametreAnahtari: 'hedefTarih', x: 5, y: 88, genislik: 160, yukseklik: 24, stil: { fontSize: 14, fontWeight: '600', color: '#90caf9', verticalAlign: 'center' } },
            ],
          } as ISablon,
          altKartSablonlari: [
            {
              id: 'hmi.is-emri.durum-guncelle',
              baslik: 'Durum Güncelle',
              simge: '🔄',
              parametreler: [
                {
                  turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', ayarlar: {
                    zorunlu: true,
                    itemSablon: { aktif: true, simgeGoster: false, renkGoster: true, aciklamaGoster: false, resimGoster: false },
                    secenekler: [
                      { label: 'Başladı', value: 'Başladı', renk: '#1890ff' },
                      { label: 'Devam', value: 'Devam', renk: '#13c2c2' },
                      { label: 'Beklemede', value: 'Beklemede', renk: '#fa8c16' },
                      { label: 'Tamamlandı', value: 'Tamamlandı', renk: '#52c41a' },
                      { label: 'İptal', value: 'İptal', renk: '#f5222d' },
                    ],
                  }
                },
                { turu: 'Sayı', ismi: 'ilerleme', baslik: 'İlerleme %', ayarlar: { min: 0, maks: 100 } },
                { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
              ],
              sablon: {
                genislik: 520, yukseklik: 200, mod: 'serbest',
                arkaPlan: { tur: 'gradient', deger: 'linear-gradient(160deg, #0d1b2a 0%, #1b2838 40%, #1a3a5f 100%)' },
                bolgeler: [],
                elementler: [
                  { id: 'ied0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 6, yukseklik: 200, stil: { fill: '#1565c0' } },
                  { id: 'ied1', tur: 'sabit-metin', icerik: '🔄', x: 4, y: 8, genislik: 40, yukseklik: 40, stil: { fontSize: 24, textAlign: 'center', verticalAlign: 'center' } },
                  { id: 'ied2', tur: 'sabit-metin', icerik: 'DURUM GÜNCELLEMESİ', x: 14, y: 8, genislik: 200, yukseklik: 18, stil: { fontSize: 9, fontWeight: '700', color: '#90caf9', letterSpacing: 2, verticalAlign: 'center' } },
                  { id: 'ied3a', tur: 'sekil', sekilTuru: 'dikdortgen', x: 15, y: 32, genislik: 180, yukseklik: 34, stil: { fill: 'rgba(21,101,192,0.15)', borderRadius: 17 } },
                  { id: 'ied3', tur: 'parametre-render', parametreAnahtari: 'durum', x: 15, y: 32, genislik: 180, yukseklik: 34, stil: { fontSize: 15, fontWeight: '700', color: '#ffffff', textAlign: 'center', verticalAlign: 'center' } },
                  { id: 'ied4', tur: 'parametre-render', parametreAnahtari: 'ilerleme', x: 55, y: 32, genislik: 100, yukseklik: 44, stil: { fontSize: 36, fontWeight: '900', color: '#90caf9', textAlign: 'center', verticalAlign: 'center' } },
                  { id: 'ied4a', tur: 'sabit-metin', icerik: '%', x: 75, y: 36, genislik: 30, yukseklik: 20, stil: { fontSize: 16, fontWeight: '600', color: '#90caf9', verticalAlign: 'center' } },
                  { id: 'ied5', tur: 'sekil', sekilTuru: 'dikdortgen', x: 4, y: 75, genislik: 450, yukseklik: 5, stil: { fill: 'rgba(255,255,255,0.06)', borderRadius: 3 } },
                  { id: 'ied6', tur: 'sabit-metin', icerik: 'İLERLEME', x: 4, y: 85, genislik: 100, yukseklik: 14, stil: { fontSize: 7, fontWeight: '600', color: 'rgba(255,255,255,0.25)', letterSpacing: 2 } },
                ],
              } as ISablon,
            },
            {
              id: 'hmi.is-emri.kalite-kontrol',
              baslik: 'Kalite Kontrol',
              simge: '✅',
              parametreler: [
                {
                  turu: 'Açılır Kutu', ismi: 'sonuc', baslik: 'Sonuç', ayarlar: {
                    zorunlu: true,
                    itemSablon: { aktif: true, simgeGoster: false, renkGoster: true, aciklamaGoster: false, resimGoster: false },
                    secenekler: [
                      { label: 'Uygun', value: 'Uygun', renk: '#52c41a' },
                      { label: 'Uygun Değil', value: 'Uygun Değil', renk: '#f5222d' },
                      { label: 'Şartlı Kabul', value: 'Şartlı Kabul', renk: '#fa8c16' },
                    ],
                  }
                },
                { turu: 'Yazı', ismi: 'olcum', baslik: 'Ölçüm Değeri' },
                { turu: 'Yazı', ismi: 'tolerans', baslik: 'Tolerans' },
                { turu: 'Yazı Alanı', ismi: 'hataTanimi', baslik: 'Hata Tanımı' },
                personelAcilirKutu('onaylayan', 'Onaylayan'),
              ],
              sablon: {
                genislik: 520, yukseklik: 200, mod: 'serbest',
                arkaPlan: { tur: 'gradient', deger: 'linear-gradient(160deg, #0d1b2a 0%, #1b3a2a 50%, #1b5e20 100%)' },
                bolgeler: [],
                elementler: [
                  { id: 'iekk0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 6, yukseklik: 200, stil: { fill: '#43a047' } },
                  { id: 'iekk1', tur: 'sabit-metin', icerik: '✅', x: 4, y: 8, genislik: 40, yukseklik: 40, stil: { fontSize: 24, textAlign: 'center', verticalAlign: 'center' } },
                  { id: 'iekk2', tur: 'sabit-metin', icerik: 'KALİTE KONTROL', x: 14, y: 8, genislik: 200, yukseklik: 18, stil: { fontSize: 9, fontWeight: '700', color: '#66bb6a', letterSpacing: 2, verticalAlign: 'center' } },
                  { id: 'iekk3a', tur: 'sekil', sekilTuru: 'dikdortgen', x: 15, y: 35, genislik: 160, yukseklik: 34, stil: { fill: 'rgba(67,160,71,0.15)', borderRadius: 17 } },
                  { id: 'iekk3', tur: 'parametre-render', parametreAnahtari: 'sonuc', x: 15, y: 35, genislik: 160, yukseklik: 34, stil: { fontSize: 15, fontWeight: '700', color: '#ffffff', textAlign: 'center', verticalAlign: 'center' } },
                  { id: 'iekk4', tur: 'sabit-metin', icerik: 'ÖLÇÜM', x: 55, y: 32, genislik: 80, yukseklik: 14, stil: { fontSize: 7, fontWeight: '700', color: 'rgba(255,255,255,0.35)', letterSpacing: 2 } },
                  { id: 'iekk5', tur: 'parametre-render', parametreAnahtari: 'olcum', x: 55, y: 40, genislik: 120, yukseklik: 24, stil: { fontSize: 14, fontWeight: '600', color: '#a5d6a7', verticalAlign: 'center' } },
                ],
              } as ISablon,
            },
            { id: 'hmi.is-emri.uretim-kaydi', baslik: 'Üretim Kaydı', simge: '📊', bilesen: 'uretim-kaydi' },
          ],
        },
      ],
    },
    {
      id: 'hmi.kalite',
      baslik: 'Kalite Kontrol',
      simge: '✅',
      aciklama: 'Kalite kontrol formu',
      renk: 'linear-gradient(135deg, #1b5e20, #43a047)',
      kaynak: 'kod',
      bilesen: 'kalite',
      parametreler: [
        { turu: 'Otomatik Kod', ismi: 'kontrolNo', baslik: 'Kontrol No', ayarlar: { kodFormat: '{PREFIX}-{YIL}-{AY}-{SAYI:3}', kodPrefix: 'KK' } },
        { turu: 'Yazı', ismi: 'urunAdi', baslik: 'Ürün Adı', ayarlar: { zorunlu: true } },
        { turu: 'Yazı', ismi: 'partNo', baslik: 'Part No' },
        { turu: 'Sayı', ismi: 'olcuDeger', baslik: 'Ölçü Değer' },
        { turu: 'Sayı', ismi: 'toleransAlt', baslik: 'Tolerans Alt' },
        { turu: 'Sayı', ismi: 'toleransUst', baslik: 'Tolerans Üst' },
        {
          turu: 'Açılır Kutu', ismi: 'sonuc', baslik: 'Sonuç', ayarlar: {
            itemSablon: { aktif: true, simgeGoster: false, renkGoster: true, aciklamaGoster: false, resimGoster: false },
            secenekler: [
              { label: 'Uygun', value: 'Uygun', renk: '#52c41a' },
              { label: 'Uygun Değil', value: 'Uygun Değil', renk: '#f5222d' },
              { label: 'Şartlı Kabul', value: 'Şartlı Kabul', renk: '#fa8c16' },
            ],
          }
        },
        personelAcilirKutu('kontrolEden', 'Kontrol Eden'),
        { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
      ],
      sablon: {
        genislik: 520, yukseklik: 240, mod: 'serbest',
        arkaPlan: { tur: 'gradient', deger: 'linear-gradient(145deg, #0a2e10 0%, #1b5e20 50%, #43a047 100%)' },
        bolgeler: [],
        elementler: [
          { id: 'kk0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 5, stil: { fill: 'rgba(255,255,255,0.12)' } },
          { id: 'kk1', tur: 'sabit-metin', icerik: '✅', x: 5, y: 8, genislik: 50, yukseklik: 50, stil: { fontSize: 32, textAlign: 'center', verticalAlign: 'center' } },
          { id: 'kk1a', tur: 'parametre-render', parametreAnahtari: 'kontrolNo', x: 16, y: 10, genislik: 160, yukseklik: 18, stil: { fontSize: 9, fontWeight: '700', color: 'rgba(165,214,167,0.7)', letterSpacing: 2, verticalAlign: 'center' } },
          { id: 'kk2', tur: 'parametre-metin', parametreAnahtari: 'urunAdi', x: 5, y: 24, genislik: 320, yukseklik: 36, stil: { fontSize: 20, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
          { id: 'kk6a', tur: 'sekil', sekilTuru: 'dikdortgen', x: 70, y: 54, genislik: 140, yukseklik: 36, stil: { fill: 'rgba(255,255,255,0.08)', borderRadius: 18 } },
          { id: 'kk6', tur: 'parametre-render', parametreAnahtari: 'sonuc', x: 70, y: 54, genislik: 140, yukseklik: 36, stil: { fontSize: 16, fontWeight: '800', color: '#ffffff', textAlign: 'center', verticalAlign: 'center' } },
          { id: 'kk8', tur: 'sabit-metin', icerik: '◆ KALİTE KONTROL FORMU', x: 55, y: 90, genislik: 250, yukseklik: 22, stil: { fontSize: 8, fontWeight: '600', color: 'rgba(165,214,167,0.3)', verticalAlign: 'center', letterSpacing: 2, textAlign: 'right' } },
        ],
      } as ISablon,
      altKartSablonlari: [
        { id: 'hmi.kalite.olcum', baslik: 'Ölçüm', simge: '📏', bilesen: 'kalite-olcum' },
      ],
    },
    {
      id: 'hmi.uretim-sayac',
      baslik: 'Üretim Sayacı',
      simge: '📊',
      aciklama: 'Tezgah üretim takibi',
      renk: 'linear-gradient(135deg, #311b92, #7c4dff)',
      kaynak: 'kod',
      bilesen: 'uretim-sayac',
      parametreler: [
        { turu: 'Yazı', ismi: 'tezgah', baslik: 'Tezgah', ayarlar: { zorunlu: true } },
        { turu: 'Yazı', ismi: 'urun', baslik: 'Ürün' },
        { turu: 'Sayı', ismi: 'hedef', baslik: 'Hedef', ayarlar: { min: 1, olaylar: { degisti: `var v = form.find(function(p){return p.ismi==='verimlilik'}); var g = form.find(function(p){return p.ismi==='gerceklesen'})?.degeri||0; if(v && itm.degeri>0) v.degeri=Math.round((g/itm.degeri)*100);` } } },
        { turu: 'Sayı', ismi: 'gerceklesen', baslik: 'Gerçekleşen', ayarlar: { olaylar: { degisti: `var v = form.find(function(p){return p.ismi==='verimlilik'}); var h = form.find(function(p){return p.ismi==='hedef'})?.degeri||0; if(v && h>0) v.degeri=Math.round((itm.degeri/h)*100);` } } },
        { turu: 'Sayı', ismi: 'fire', baslik: 'Fire' },
        { turu: 'Sayı', ismi: 'verimlilik', baslik: 'Verimlilik %', ayarlar: { sadeceOkunur: true } },
      ],
      sablon: {
        genislik: 520, yukseklik: 200, mod: 'serbest',
        arkaPlan: { tur: 'gradient', deger: 'linear-gradient(145deg, #1a0a3e 0%, #311b92 50%, #7c4dff 100%)' },
        bolgeler: [],
        elementler: [
          { id: 'us0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 5, stil: { fill: 'rgba(255,255,255,0.12)' } },
          { id: 'us1', tur: 'sabit-metin', icerik: '📊', x: 5, y: 6, genislik: 46, yukseklik: 46, stil: { fontSize: 28, textAlign: 'center', verticalAlign: 'center' } },
          { id: 'us2', tur: 'parametre-metin', parametreAnahtari: 'tezgah', x: 15, y: 6, genislik: 260, yukseklik: 28, stil: { fontSize: 18, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
          { id: 'us4', tur: 'sabit-metin', icerik: 'HEDEF', x: 5, y: 40, genislik: 100, yukseklik: 14, stil: { fontSize: 7, fontWeight: '700', color: 'rgba(179,157,219,0.6)', letterSpacing: 2, textAlign: 'center' } },
          { id: 'us5', tur: 'parametre-render', parametreAnahtari: 'hedef', x: 5, y: 46, genislik: 100, yukseklik: 36, stil: { fontSize: 30, fontWeight: '900', color: '#b39ddb', textAlign: 'center', verticalAlign: 'center' } },
          { id: 'us6', tur: 'sabit-metin', icerik: 'GERÇEKLEŞEN', x: 28, y: 40, genislik: 120, yukseklik: 14, stil: { fontSize: 7, fontWeight: '700', color: 'rgba(124,77,255,0.8)', letterSpacing: 2, textAlign: 'center' } },
          { id: 'us7', tur: 'parametre-render', parametreAnahtari: 'gerceklesen', x: 28, y: 46, genislik: 120, yukseklik: 36, stil: { fontSize: 30, fontWeight: '900', color: '#7c4dff', textAlign: 'center', verticalAlign: 'center' } },
          { id: 'us8', tur: 'sabit-metin', icerik: 'FİRE', x: 55, y: 40, genislik: 80, yukseklik: 14, stil: { fontSize: 7, fontWeight: '700', color: 'rgba(255,138,128,0.6)', letterSpacing: 2, textAlign: 'center' } },
          { id: 'us9', tur: 'parametre-render', parametreAnahtari: 'fire', x: 55, y: 46, genislik: 80, yukseklik: 36, stil: { fontSize: 30, fontWeight: '900', color: '#ff8a80', textAlign: 'center', verticalAlign: 'center' } },
          { id: 'us16', tur: 'sabit-metin', icerik: '◆ ÜRETİM SAYACI', x: 3, y: 86, genislik: 200, yukseklik: 18, stil: { fontSize: 8, fontWeight: '600', color: 'rgba(179,157,219,0.35)', verticalAlign: 'center', letterSpacing: 2 } },
        ],
      } as ISablon,
      altKartSablonlari: [
        { id: 'hmi.uretim-sayac.durus', baslik: 'Duruş Kaydı', simge: '⏸️', bilesen: 'durus-kaydi' },
      ],
    },
    {
      id: 'hmi.vardiya-devir',
      baslik: 'Vardiya Devir Teslim',
      simge: '🔄',
      aciklama: 'Vardiya devir teslim kaydı',
      renk: 'linear-gradient(135deg, #004d40, #00897b)',
      kaynak: 'kod',
      bilesen: 'vardiya-devir',
      parametreler: [
        {
          turu: 'Açılır Kutu', ismi: 'vardiya', baslik: 'Vardiya', ayarlar: {
            zorunlu: true,
            itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: false, resimGoster: false },
            secenekler: [
              { label: 'Sabah (06-14)', value: 'Sabah', simge: '☀️' },
              { label: 'Öğle (14-22)', value: 'Öğle', simge: '🌤️' },
              { label: 'Gece (22-06)', value: 'Gece', simge: '🌙' },
            ],
          }
        },
        { ...personelAcilirKutu('devreden', 'Devreden'), ayarlar: { ...personelAcilirKutu('devreden', 'Devreden').ayarlar, zorunlu: true } } as any,
        { ...personelAcilirKutu('devralan', 'Devralan'), ayarlar: { ...personelAcilirKutu('devralan', 'Devralan').ayarlar, zorunlu: true } } as any,
        {
          turu: 'Açılır Kutu', ismi: 'makineDurumu', baslik: 'Makine Durumu', ayarlar: {
            itemSablon: { aktif: true, simgeGoster: false, renkGoster: true, aciklamaGoster: false, resimGoster: false },
            secenekler: [
              { label: 'Çalışıyor', value: 'Çalışıyor', renk: '#52c41a' },
              { label: 'Arızalı', value: 'Arızalı', renk: '#f5222d' },
              { label: 'Bakımda', value: 'Bakımda', renk: '#fa8c16' },
              { label: 'Boşta', value: 'Boşta', renk: '#8c8c8c' },
            ],
          }
        },
        { turu: 'Sayı', ismi: 'uretimAdedi', baslik: 'Üretim Adedi' },
        { turu: 'Sayı', ismi: 'fireAdedi', baslik: 'Fire Adedi' },
        { turu: 'Yazı Alanı', ismi: 'bekleyenIsler', baslik: 'Bekleyen İşler' },
        { turu: 'Yazı Alanı', ismi: 'onemliNotlar', baslik: 'Önemli Notlar' },
      ],
      sablon: {
        genislik: 520, yukseklik: 260, mod: 'serbest',
        arkaPlan: { tur: 'gradient', deger: 'linear-gradient(145deg, #002620 0%, #004d40 50%, #00897b 100%)' },
        bolgeler: [],
        elementler: [
          { id: 'vd0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 5, stil: { fill: 'rgba(255,255,255,0.12)' } },
          { id: 'vd1', tur: 'sabit-metin', icerik: '🔄', x: 5, y: 8, genislik: 50, yukseklik: 50, stil: { fontSize: 32, textAlign: 'center', verticalAlign: 'center' } },
          { id: 'vd1b', tur: 'parametre-render', parametreAnahtari: 'vardiya', x: 16, y: 10, genislik: 140, yukseklik: 26, stil: { fontSize: 12, fontWeight: '700', color: '#a7ffeb', textAlign: 'center', verticalAlign: 'center' } },
          { id: 'vd11', tur: 'sabit-metin', icerik: '◆ VARDİYA DEVİR TESLİM', x: 3, y: 90, genislik: 250, yukseklik: 26, stil: { fontSize: 8, fontWeight: '600', color: 'rgba(167,255,235,0.35)', verticalAlign: 'center', letterSpacing: 2 } },
        ],
      } as ISablon,
      altKartSablonlari: [
        { id: 'hmi.vardiya.not', baslik: 'Vardiya Notu', simge: '📋', bilesen: 'vardiya-notu' },
      ],
    }, */
  ];

  icerikEkle(ek: any = null) {
    if (!ek) {
      ek = { turu: 'UYGULAMAICERIK', _id: '', parametreler: [] };
    }
    this.kart?.veri?.icerikler?.push({
      _id: new FikoYTId().toString(), aciklama: '', html: '', ek, sifre: null,
    }) ?? 0;
  }

  sifirla() {
    this.kart = {
      _id: new FikoYTId().toString(),
      vt: 'FikoYT.sistem.hareketler' as IVT,
      yol: 'FikoYT.sistem.hareketler.kalem' as IYollar,
      turu: IKartTuru.KART,
      gizlilik: 'Herkese Açık',
      kisiler: [],
      veri: {
        solSimge: { aciklama: undefined, baslik: 'HMI', renkArka: '#f5222d', renkYazi: '#fff' },
        kurdela: { aciklama: undefined, baslik: 'Üretim', renkArka: undefined, renkYazi: undefined },
        icerikler: [],
      },
    };
    this.icerikEkle();
  }

  aktifEtSonSayfa() {
    this.aktifIcerikNo = (this.kart?.veri?.icerikler?.length ?? 1) - 1;
  }
}
